import * as React from 'react';
import { UitkCarousel } from 'uitk-react-carousel';
import { DestinationRefinementCard } from './destination-refinement-card';
import { PwaHsrPropertyDestinationRefinement } from 'src/common/__generated__/api';
import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentClass, LocalizedComponentProps, withLocalization } from 'bernie-l10n';

export interface DestinationRefinementCarouselProps extends LocalizedComponentProps {
  title: string;
  destinations: PwaHsrPropertyDestinationRefinement.Destinations[];
  showAffinities?: boolean;
  showDescription?: boolean;
  analytics?: AnalyticsStore;
}

export const DestinationRefinementCarousel = withLocalization((props: DestinationRefinementCarouselProps) => {
  const { title, analytics, destinations, showDescription, showAffinities, l10n } = props;
  const carouselProps = {
    itemsVisible: { lg: 3, md: 2, sm: 1 },
    pageBy: 1,
    peekWidth: 12,
    className: 'all-b-margin-six',
    carouselName: 'destinationRefinement',
    buttonText: {
      nextButton: l10n.formatText('carousel.nextItem'),
      prevButton: l10n.formatText('carousel.previousItem')
    }
  };

  return (
    <UitkCarousel
      headline={title}
      analytics={analytics && analytics.setupTracker(carouselProps.carouselName, 'Carousel interaction')}
      {...carouselProps}
    >
      {destinations.map((destination, position) => (
        <li className={'uitk-cell uitk-flex uitk-flex-align-items-stretch'} key={`refined-destination-${position}`}>
          {destination && <DestinationRefinementCard {...{ position, destination, showDescription, showAffinities }} />}
        </li>
      ))}
    </UitkCarousel>
  );
}) as LocalizedComponentClass<DestinationRefinementCarouselProps>;
